import * as React from 'react';
import NextLink from 'next/link';

const Link = ({
  href,
  className = '',
  children,
  onClick,
  style,
  target,
}: {
  href: string;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
  style?: React.CSSProperties;
  target?: string;
}) => (
  <NextLink href={href}>
    {}
    <a className={className} onClick={onClick} style={{ ...style }} target={target}>
      {children}
    </a>
  </NextLink>
);

export default Link;
